import { useMutation } from "@apollo/client";

import {
  UpdateHarvestAccountConfigsMutation,
  UpdateHarvestAccountConfigsMutationVariables,
} from "@ctypes";
import { UPDATE_HARVEST_ACCOUNT_CONFIGS, USER } from "@graphql";

export const useUpdateHarvestAccountConfigs = () => {
  return useMutation<
    UpdateHarvestAccountConfigsMutation,
    UpdateHarvestAccountConfigsMutationVariables
  >(UPDATE_HARVEST_ACCOUNT_CONFIGS, {
    refetchQueries: [{ query: USER }],
    awaitRefetchQueries: true,
  });
};
